import React from "react";

interface SynkPassProps {
  customUrl?: string;
  targetId?: string;
  username?: string;
}

const SynkPass: React.FC<SynkPassProps> = ({
  customUrl,
  targetId,
  username,
}) => {
  // URL directe sans useState ni useEffect
  let url = "https://synkpass.synk.ws";

  if (customUrl) {
    url = customUrl;
  } else if (targetId && username) {
    url = `https://synkpass.synk.ws/?url=${targetId}&username=${username}`;
  }

  // Logs de débogage si en mode dev
  if (process.env.REACT_APP_DEV_MODE === "true") {
    console.log("🔐 SynkPass - Props reçues:");
    console.log("  - customUrl:", customUrl);
    console.log("  - targetId:", targetId);
    console.log("  - username:", username);
    console.log("  - URL finale:", url);
  }

  return (
    <div className="w-full h-full">
      <iframe
        src={url}
        title="Synk Pass"
        className="w-full h-full border-none"
        sandbox="allow-scripts allow-same-origin allow-popups allow-downloads allow-clipboard-write"
        allow="camera; microphone; fullscreen; clipboard-write"
      />
    </div>
  );
};

export default SynkPass;
